import type { PlayerAdapter } from '../../src/core/types';
import type { YouTubePlayer } from './youtubeIframe';

export class IFramePlayerAdapter implements PlayerAdapter {
  private player: YouTubePlayer | null = null;
  private state = -1;

  setPlayer(player: YouTubePlayer): void {
    this.player = player;
  }

  setState(state: number): void {
    this.state = state;
  }

  isReady(): boolean {
    return this.player !== null;
  }

  getCurrentTime(): number {
    return this.player?.getCurrentTime() ?? 0;
  }

  seek(time: number): void {
    this.player?.seekTo(Math.max(0, time), true);
  }

  play(): void {
    this.player?.playVideo();
  }

  pause(): void {
    this.player?.pauseVideo();
  }

  isPaused(): boolean {
    return this.state !== 1 && this.state !== 3;
  }

  getPlaybackRate(): number {
    return this.player?.getPlaybackRate() ?? 1;
  }
}
